import PosCartActions from '../../../actions/PosCartActions';

import UserStore from '../../../stores/UserStore';

class NetaAutoPrice extends React.Component {

    constructor(props) {
        super(props);

        this.netaAutoPrice = this.netaAutoPrice.bind(this);
    }

    netaAutoPrice () {
        $('#pos-header-neta-price').css({ 'backgroundColor' : '#a9ea9f' })

        setTimeout(() => {
            $('#pos-header-neta-price').css({ 'backgroundColor' : '#ebebeb' })
        }, 500);

        PosCartActions.netaAutoPrice(this.props.guest, true);
    }

    render() {
        var loc   = UserStore.getApiData().LspId;

        if (loc !== '1067' && loc !== '18')
            return null;

        return (
            <li
                className='pos-header__neta'
                onClick={this.netaAutoPrice}
                title='Auto Price'
                id='pos-header-neta-price'>

                <img
                    src='/assets/neta_auto_price.png'
                    className='pos-header__neta--price' />
            </li>
        );
    }
}

export default NetaAutoPrice;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/neta/NetaAutoPrice.react.jsx